'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const toPlainDateString = (date) => date.toISOString().split('T')[0];

exports.toPlainDateString = toPlainDateString;
//# sourceMappingURL=to-plain-date-string.js.map
